import React, { useEffect, useState } from "react";
import {
    Modal,
    Box,
    Switch,
    Typography,
    Card,
    CardContent,
    Button,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Accordion,
    AccordionSummary,
    AccordionDetails,
    Select,
    styled,
    MenuItem,
    InputLabel,
    FormControl,
    IconButton,
    AppBar,
    Tab, Tabs,
    Toolbar,
    Paper,
    TableContainer,
    Checkbox,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import CloseIcon from "@mui/icons-material/Close";
import Stack from '@mui/material/Stack';
// import Header from '../partials/header';
// import LeftSidebar from '../partials/leftSidebar';
import sitesIcon from '../../assets/images/icon/sites.svg';
import OptionIcon from '../../assets/images/icon/Option.svg';
import customersIcon from '../../assets/images/icon/customers.svg';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import { TextField } from "formik-material-ui";
// import InfoHoverTooltip from "@/components/Tooltips/InfoHover";
import { useNavigate } from "react-router-dom";
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import LicenseDetailModal from "./LicenseDetailModal";
import { getMethod, putMethod } from "../../../services/apiService";
import { getUserId } from "../../../helper/helper";
import { Link } from "react-router-dom";
import search from "../../../assets/images/icon/search.svg"
import { clearStorageAndCookies } from "../../../services/authService";
import { ToastContext, useToastContext } from "../../../context/toastContext";

export const AntSwitch = styled(Switch)(({ theme }) => ({
    width: 40, // Slightly smaller width for the switch
    height: 24, // Slightly smaller height for the switch
    padding: 0,
    display: "flex",
    "&:active": {
        "& .MuiSwitch-thumb": {
            width: "14px", // Slightly smaller thumb size
            height: "14px", // Slightly smaller thumb size
        },
    },
    "& .MuiSwitch-switchBase": {
        padding: 4, // Adjusted padding for a smaller thumb
        "&.Mui-checked": {
            transform: "translateX(16px)", // Adjusted translation for smaller switch
            color: "#1F2F34",
            "& .MuiSwitch-thumb": {
                backgroundColor: "#1E2121", // Make the thumb black when enabled
            },
            "& + .MuiSwitch-track": {
                opacity: 1,
                backgroundColor: "#17B2EB",
                border: "1.5px solid #17B2EB", // Thicker border on active state
            },
        },
    },
    "& .MuiSwitch-thumb": {
        width: "14px", // Slightly smaller thumb size
        height: "14px", // Slightly smaller thumb size
        margin: "1px", // Adjusted margin to center the thumb
        borderRadius: "50%", // Ensuring the thumb remains perfectly round
        boxShadow: "none",
        transition: theme.transitions.create(["width"], {
            duration: 300,
        }),
    },
    "& .MuiSwitch-track": {
        opacity: 1,
        backgroundColor: "transparent",
        boxSizing: "border-box",
        border: "1.5px solid var(--text-text-tertiary, #A5A8A9)",
        borderRadius: 24 / 2, // Adjusted border radius for the smaller track
    },
}));
interface AllData {
    license: {
        key: string;
        partner: string;
        data: {
            name: string;
            quantity: number;
            createdTime: number;
            activationTime: number;
            expiryTime: number;
            status: number;
            licenseType: number;
            analyticType: number;
        };
    };
    countData: {
        total: number;
        active: number;
        available: number;
    };
}


function LicenseTabTwo() {
    const { setToast } = useToastContext() as ToastContext;

    const navigate = useNavigate();

    const [openModal, setOpenModal] = useState(false);

    const [selectedRow, setSelectedRow] = useState(null);

    const handleRowClick = (row: any) => {
        setSelectedRow(row); // Save the clicked row data
        setOpenModal(true);  // Open the modal
    };

    const handleClose = () => {
        setOpenModal(false); // Close the modal
    };

    const rowsData = [
        {
            createdOn: "ABC-124",
            customer: "30",
            sitedevice: "112",
            feature: "2",
            ExpiryD: "12/12/12",
            val: "Active",
            orderId: "222",
            status: "enable",
            quantity: "4"
        },
        {
            createdOn: "ABC-124",
            customer: "30",
            sitedevice: "112",
            feature: "2",
            ExpiryD: "12/12/12",
            val: "Active",
            orderId: "222",
            status: "enable",
            quantity: "4"
        },
    ];



    const [selectedRows, setSelectedRows] = useState<number[]>([]);
    const [rows, setRows] = useState(rowsData);
    const [allData, setAllData] = useState<AllData[]>([]);
    const handleCheckboxChange = (licenseKey: any) => {
        setSelectedRows((prev: any) =>
            prev.includes(licenseKey)
                ? prev.filter((key: any) => key !== licenseKey)
                : [...prev, licenseKey]
        );
    };

    const isRowSelected = (licenseKey: any) => selectedRows.includes(licenseKey);

    useEffect(() => {
        fetchCustomerList();
        const storedValue = localStorage.getItem('userInfo');
    }, [openModal]);

    let user = getUserId()


    const fetchCustomerList = async () => {

        const respo = await getMethod("partner/all/license/" + user);
        setAllData(respo?.data.result)
    };

    function getStatusDetails(status: any) {
        switch (status) {
            case 0:
                return { text: "Active", color: "green" };
            case 1:
                return { text: "Suspended", color: "orange" };
            case 2:
                return { text: "Expired", color: "#FB462E" };
            case 3:
                return { text: "Deleted", color: "gray" };
            default:
                return { text: "Unknown status", color: "black" };
        }
    }
    type StatusIndicatorProps = {
        status: number; // Explicitly declare the type of 'status'
    };

    function StatusIndicator({ status }: StatusIndicatorProps) {
        const { text, color } = getStatusDetails(status);

        return (
            <span style={{ display: "flex", alignItems: "center", gap: "5px" }}>
                <span
                    style={{
                        display: "inline-block",
                        width: "10px",
                        height: "10px",
                        borderRadius: "50%",
                        backgroundColor: color,
                    }}
                ></span>
                {text}
            </span>
        );
    }

    function convertTimestampToDate(timestamp: number): string {
        const formattedDate = new Date(timestamp).toLocaleString();
        return formattedDate.replace(',', '  |');
    }


    const handleToggleChange = async (row: any) => {
        setOpenModal(false)
        const newStatus = row.license.data.status === 0 ? 1 : 0; // Toggle between 0 (disabled) and 1 (enabled)

        const payload = {
            "key": row.license.key,
            "data": {
                "status": newStatus,
            }
        };


            const response = await putMethod("partner/license", payload);

            if (response?.status === 200) {
                setToast(response?.data?.message, "success");

                const updatedRow = { ...row };
                updatedRow.license.data.status = newStatus;
                setAllData(prevData =>
                    prevData.map(item =>
                        item.license.key === updatedRow.license.key ? updatedRow : item
                    )
                );
                setOpenModal(false);
    
            } else {
                setToast(response?.data?.message, "error");
            }




    };

    const [filteredData, setFilteredData] = useState<AllData[]>([]);
    const [searchText, setSearchText] = useState("")

    const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
        const searchText = e.target.value.toLowerCase();
        setSearchText(searchText)
        const filtered = allData.filter((item) => {
            const { name } = item.license.data;


            return (
                name.toLowerCase().includes(searchText)
            );
        });

        setFilteredData(filtered); // Update the filtered data state
    }
    return (
        <>
            <Box sx={{ display: "flex", alignContent: "space-between", justifyContent: "space-between", gap: "32px", padding: "1rem" }}>
                <div
                    style={{
                        width: 468,
                        height: 41,
                        padding: 12,
                        borderRadius: 30,
                        border: "1px solid #5a5f60",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        background: "#1F2F34",
                    }}
                >
                    <div style={{ display: "flex", alignItems: "center" }}>
                        <img
                            src={search}
                            alt="Search Icon"
                            style={{ cursor: "pointer" }}
                        />
                        <input
                            onChange={handleSearch}
                            placeholder="Search by feature"
                            style={{
                                background: "#1F2F34",
                                border: "none",
                                padding: 0,
                                margin: 0,
                                marginLeft: 8,
                                color: "#FFF",
                                width: 368,
                            }}
                        />


                    </div>


                </div>

                <Link to="/orders/create" style={{
                    textDecoration: "none",
                    color: "inherit",

                }}>

                    <button className="add-btn" style={{ cursor: "pointer" }}>
                        Create New Order
                    </button>
                </Link>
            </Box>
            <TableContainer
                component={Paper}
                sx={{ backgroundColor: "#03171f", padding: "1rem" }}
            >
                <Table sx={{ backgroundColor: "#03171f", border: "1px solid #313838" }}>
                    {/* Table Header */}
                    <TableHead>
                        <TableRow style={{ borderBottom: "2px solid #313838" }}>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            />
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Created On
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Feature
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Expiry Date
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    width: "120px",
                                    fontSize: "16px",
                                }}
                            >
                                Validity
                            </TableCell>
                            {/* <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Order ID
                            </TableCell> */}
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Status
                            </TableCell>
                            <TableCell
                                sx={{
                                    color: "#E2E3E3",
                                    borderColor: "#313838",
                                    fontWeight: "500",
                                    fontSize: "16px",
                                }}
                            >
                                Quantity
                            </TableCell>

                        </TableRow>
                    </TableHead>

                    {/* Table Body */}
                    <TableBody>
                        {(searchText ? filteredData : allData)?.map((row, index) => (

                            <TableRow
                                key={index}
                                onClick={() => handleRowClick(row)}
                                sx={{
                                    backgroundColor: isRowSelected(index)
                                        ? "#1a2a2f"
                                        : "inherit",
                                    cursor: "pointer",
                                }}
                            >
                                {/* Checkbox Column */}
                                <TableCell
                                    sx={{
                                        color: "#B4B7B8",
                                        borderColor: "#313838",
                                        width: "50px",
                                    }}
                                >
                                    {/* <Checkbox
                                        checked={isRowSelected(index)}
                                        onChange={() => handleCheckboxChange(index)}
                                        sx={{ color: "#B4B7B8" }}
                                    /> */}
                                </TableCell>
                                {/* Data Columns */}
                                <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >
                                    {convertTimestampToDate(row?.license.data.createdTime)}
                                    {/* <strong>{row.license.data.createdTime}</strong> */}

                                </TableCell>
                                <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >

                                    {row?.license.data.name}
                                </TableCell>
                                <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >
                                    {convertTimestampToDate(row?.license.data.expiryTime)}
                                </TableCell>
                                <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >
                                    < StatusIndicator status={row?.license.data.status} />
                                </TableCell>
                                {/* <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >

                                    "row.orderId"
                                </TableCell> */}
                                <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >

                                    {/* {row.license.data.status} */}
                                    <AntSwitch
                                        // disabled={true}
                                        checked={row?.license.data.status == 0 ? true : false}
                                        onChange={(e) => handleToggleChange(row)} inputProps={{ "aria-label": "ant design" }} />
                                </TableCell>
                                <TableCell
                                    sx={{ color: "#B4B7B8", borderColor: "#313838" }}
                                >
                                    {row?.license.data.quantity}
                                </TableCell>

                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>


            {
                openModal && <LicenseDetailModal setOpenModal={setOpenModal} openModal={openModal} handleCloseModal={handleClose} selectedRow={selectedRow} />
            }

        </>
    )
}

export default LicenseTabTwo